/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-file': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="none" d="M1.4 1.4h17.1v17.1H1.4z"/><g _fill="#646464"><path pid="1" d="M10.9 7.1H9.1V10H6.6v1.9h2.6v2.9h1.7v-2.9h2.6V10h-2.6V7.1z"/><path pid="2" d="M16.9 3.3H9.5L8 1.7c0-.1-.1-.2-.2-.2s-.2-.1-.3-.1H3.1c-.9 0-1.7.9-1.7 1.9v13.3c0 1.1.8 1.9 1.7 1.9h13.7c.9 0 1.7-.9 1.7-1.9V5.2c.1-1-.7-1.9-1.6-1.9zM3.1 16.7V5.2h13.7v11.4H3.1z"/></g>'
  }
})
